<script setup lang="ts">
import NavigationBar from '@/components/NavigationBar.vue';
import FooterSection from '@/components/FooterSection.vue';
</script>

<template>
  <a href="#main" class="skip-link">Zum Inhalt springen</a>
  <div class="app">
    <NavigationBar />
    <main id="main" class="main-content">
      <RouterView />
    </main>
    <FooterSection />
  </div>
</template>

<style scoped>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

.skip-link {
  position: absolute;
  top: -100%;
  left: var(--spacing-4);
  z-index: 200;
  padding: var(--spacing-2) var(--spacing-4);
  background: var(--color-primary);
  color: #fff;
  border-radius: var(--radius-md);
}

.skip-link:focus {
  top: var(--spacing-4);
}
</style>
